import * as React from 'react'
import { useTranslation } from 'hooks'
import { Provider } from './ProviderStep'
import * as S from './ConsignmentRetrieval.styles'

interface ConfirmStepProps {
  provider: Provider
  fileName: string
  productTitle: string
  size: string
  submitError: string | null
}

const ConfirmStep: React.FC<ConfirmStepProps> = ({
  provider,
  fileName,
  productTitle,
  size,
  submitError
}) => {
  const { t } = useTranslation()

  return (
    <>
      <S.SummaryCard>
        <S.SummaryRow>
          <S.SummaryLabel>
            {t('views.account.consignment_retrieval.confirm_product')}
          </S.SummaryLabel>
          <S.SummaryValue>{productTitle}</S.SummaryValue>
        </S.SummaryRow>
        <S.SummaryRow>
          <S.SummaryLabel>
            {t('views.account.consignment_retrieval.confirm_size')}
          </S.SummaryLabel>
          <S.SummaryValue>{size}</S.SummaryValue>
        </S.SummaryRow>
        <S.SummaryRow>
          <S.SummaryLabel>
            {t('views.account.consignment_retrieval.confirm_provider')}
          </S.SummaryLabel>
          <S.SummaryValue>{provider.name}</S.SummaryValue>
        </S.SummaryRow>
        <S.SummaryRow>
          <S.SummaryLabel>
            {t('views.account.consignment_retrieval.confirm_label')}
          </S.SummaryLabel>
          <S.SummaryValue>{fileName}</S.SummaryValue>
        </S.SummaryRow>
        <S.SummaryRow>
          <S.SummaryLabel>
            {t('views.account.consignment_retrieval.confirm_fee')}
          </S.SummaryLabel>
          <S.FeeHighlight>{provider.fee}</S.FeeHighlight>
        </S.SummaryRow>
      </S.SummaryCard>

      <S.Caption>
        {t('views.account.consignment_retrieval.fee_caption')}
      </S.Caption>

      {submitError && <S.BalanceWarning>{submitError}</S.BalanceWarning>}
    </>
  )
}

export default ConfirmStep
